export const AddOnsPath = {
  REVIEW: 'review/:adjustmentId',
}
